/**
 * returns an ID of a last seen news and its controller
 */

import { useState } from 'react';
import { INewsItem } from '../../reducers/news';

const useLastSeen = (items: INewsItem[]) => {

  let localStorageItem = 0;
  if (window.localStorage) {
    localStorageItem = Number(localStorage.getItem('LastSeenNewsId')) || 0;
  }
  const [lastSeen, setLastSeen] = useState(localStorageItem);

  const updateLastSeen = () => {
    if (items[0] && (lastSeen !== items[0].id)) {
      localStorage.setItem('LastSeenNewsId', String(items[0].id));
      setLastSeen(items[0].id);
    }
  };

  return {
    lastSeen,
    updateLastSeen
  };

};

export default useLastSeen;